module.exports = __webpack_public_path__ + "static/media/Name items with the same shape.79b9d117.mp3";